/* Gorilla Karts product page v2 — behaviour ported from the headless ProductPageV2.
   Progressive enhancement: without JS the page still shows everything (all tabs' content is
   in the HTML, the trust rows sit in a grid, drawers are simply never opened) and Add to cart
   is a normal form submit. 2026-08-22. */
(function () {
  if (window.__gkPdp) return;
  window.__gkPdp = true;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  function money(pence, fmt) {
    // Shopify money formats: {{amount}} 1,234.56 | {{amount_no_decimals}} 1,235 | {{amount_with_comma_separator}} 1.234,56
    // | {{amount_no_decimals_with_comma_separator}} 1.235 | {{amount_with_apostrophe_separator}} 1'234.56
    // | {{amount_with_space_separator}} 1 234,56 | {{amount_no_decimals_with_space_separator}} 1 235
    // | {{amount_with_period_and_space_separator}} 1 234.56. Whole amounts drop the ",00"/".00" (brand style).
    fmt = fmt || '£{{amount}}';
    var m = fmt.match(/\{\{\s*(amount[a-z_]*)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var noDec = key.indexOf('no_decimals') !== -1;
    var comma = key.indexOf('comma_separator') !== -1;
    var dec = (comma || key === 'amount_with_space_separator') ? ',' : '.';
    var thou = comma ? '.' : key.indexOf('apostrophe') !== -1 ? "'" : key.indexOf('space') !== -1 ? ' ' : ',';
    var n = Math.abs(pence) / 100;
    var whole = noDec ? String(Math.round(n)) : n.toFixed(2).split('.')[0];
    var frac = noDec ? '' : n.toFixed(2).split('.')[1];
    whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thou);
    var v = (pence < 0 ? '-' : '') + whole + (frac && frac !== '00' ? dec + frac : '');
    return m ? fmt.replace(m[0], v) : fmt + v;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c];
    });
  }
  function parseJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* Add to cart without leaving the page.

     Both routes off this page used to end at /cart: with accessories ticked the
     JS posted them and then set window.location, and with none ticked the button
     fell through to a plain form POST, which Shopify answers with a redirect to
     the cart page. Either way the customer lost the product page — the "it just
     jumps to the cart" that a slide-out drawer exists to avoid. The drawer now
     carries suggestions of its own, so there is something worth staying for.

     If anything the drawer needs is missing the old behaviour still runs, and a
     failed request falls back to submitting the form, so nobody is left stuck. */
  function gkAddToCart(items, btn, form) {
    if (!items.length) return;
    if (btn) btn.setAttribute('aria-busy', 'true');
    var done = function () { if (btn) btn.removeAttribute('aria-busy'); };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify({items: items}),
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function () {
        var sf = window.sharedFunctions;
        var opener = document.querySelector('[data-cart-sidebar]');
        if (opener && sf && typeof sf.updateSidebarCart === 'function' &&
            window.Shopify && typeof Shopify.getCart === 'function') {
          Shopify.getCart(function (cart) {
            try { sf.updateSidebarCart(cart); } catch (e) { /* drawer refreshes itself */ }
            opener.click();
            done();
          });
        } else {
          window.location.href = '/cart';   /* no drawer here — the old behaviour */
        }
      })
      .catch(function () {
        done();
        if (form) form.submit();
      });
  }
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var FOCUSABLE = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

  /* One keyboard handler for every overlay (drawers + lightbox): Escape closes the open one,
     Tab cycles inside it. */
  var openOverlay = null; // {el, panel, close}
  document.addEventListener('keydown', function (e) {
    if (!openOverlay) return;
    if (e.key === 'Escape') { openOverlay.close(); return; }
    if (e.key === 'Tab' && openOverlay.panel) {
      var f = all(FOCUSABLE, openOverlay.panel).filter(function (x) { return !x.hidden && x.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    if (openOverlay.onKey) openOverlay.onKey(e);
  });
  var prevOverflow = '';
  function lockScroll(on) {
    if (on) { prevOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; }
    else document.body.style.overflow = prevOverflow;
  }

  ready(function () {
    var root = document.querySelector('[data-gk-pdp]');
    var lower = document.querySelector('[data-gk-pdp-lower]');
    var scope = root || lower;
    if (!scope) return;
    var moneyFormat = (root && root.getAttribute('data-money-format')) || '£{{amount}}';
    var name = ((root && root.getAttribute('data-name')) || (lower && lower.getAttribute('data-name')) || '').trim();

    /* ---------- 0. Sticky gallery column: sit under the theme header ---------- */
    if (root && root.querySelector('.gk-p2-left')) {
      var hdr = document.querySelector('[data-sticky-type], .header-sticky, .sticky-header, #header, .header');
      var setTop = function () {
        var h = 0;
        if (hdr) {
          var cs = getComputedStyle(hdr);
          if (cs.position === 'fixed' || cs.position === 'sticky') h = hdr.getBoundingClientRect().height;
        }
        root.style.setProperty('--gk-stick-top', (h ? Math.round(h) + 16 : 16) + 'px');
      };
      setTop();
      window.addEventListener('resize', setTop);
      var measuredScrolled = false;
      window.addEventListener('scroll', function () {
        if (!measuredScrolled && window.scrollY > 320) { measuredScrolled = true; setTop(); }
      }, {passive: true});
    }

    /* ---------- 1. Gallery: thumbnails swap the main image, spec callouts follow it ---------- */
    if (root) {
      var main = root.querySelector('[data-gk-main-img]');
      var mainVid = root.querySelector('[data-gk-main-vid]');
      // Headline video (gk_hero_video): HLS where the browser plays it itself (iPhone/iPad/Safari), else the 1080p mp4.
      if (mainVid && mainVid.hasAttribute('data-gk-hero-playing')) {
        var heroHls = mainVid.getAttribute('data-gk-hero-hls');
        mainVid.src = (heroHls && mainVid.canPlayType('application/vnd.apple.mpegurl')) ? heroHls : mainVid.getAttribute('data-gk-hero-mp4');
        mainVid.muted = true;
        var heroPlay = mainVid.play(); if (heroPlay && heroPlay.catch) heroPlay.catch(function () {});
      }
      var showImg = function () {
        if (!mainVid || mainVid.hidden) return;
        mainVid.pause(); mainVid.hidden = true;
        if (main) { main.hidden = false; main.parentNode.classList.remove('is-vid'); }
      };
      var ovlEl = root.querySelector('[data-gk-ovl]');
      var overlays = parseJSON(root.querySelector('[data-gk-overlays]')) || [];
      var applyOverlay = function (src) {
        if (!ovlEl) return;
        src = (src || '').toLowerCase();
        var o = null;
        for (var i = 0; i < overlays.length; i++) {
          if (overlays[i] && overlays[i].m && src.indexOf(overlays[i].m) >= 0) { o = overlays[i]; break; }
        }
        if (!o || !o.l || !o.l.length) { ovlEl.hidden = true; return; }
        ovlEl.className = 'gk-p2-ovl gk-p2-ovl-' + (['tl', 'tr', 'br'].indexOf(o.p) >= 0 ? o.p : 'bl');
        ovlEl.innerHTML = o.l.map(function (L) {
          return '<span class="gk-p2-ovl-row"><b>' + esc(L[0]) + '</b><small>' + esc(L[1] || '') + '</small></span>';
        }).join('');
        ovlEl.hidden = false;
      };
      if (mainVid && !mainVid.hidden) { if (ovlEl) ovlEl.hidden = true; }  // headline video playing
      else applyOverlay(main && main.getAttribute('data-gk-src'));
      all('[data-gk-thumb]', root).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var src = btn.getAttribute('data-gk-thumb');
          if (main && src) { showImg(); main.src = src; main.alt = btn.getAttribute('data-gk-alt') || ''; }
          all('.gk-p2-thumb', root).forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          applyOverlay(btn.getAttribute('data-gk-src'));
          showThumb(btn);
        });
      });
      // Product videos: the main picture becomes a muted looping player (fetched only when tapped).
      all('[data-gk-thumb-vid]', root).forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!mainVid || !main) return;
          // adaptive stream where the browser plays HLS itself (iPhone/iPad/Safari), else the 1080p mp4
          var hls = btn.getAttribute('data-gk-thumb-vid-hls');
          var v = (hls && mainVid.canPlayType('application/vnd.apple.mpegurl')) ? hls : btn.getAttribute('data-gk-thumb-vid');
          if (mainVid.getAttribute('src') !== v) { mainVid.setAttribute('poster', btn.getAttribute('data-gk-poster') || ''); mainVid.src = v; }
          mainVid.setAttribute('aria-label', btn.getAttribute('data-gk-alt') || '');
          mainVid.classList.toggle('is-tall', btn.getAttribute('data-gk-vid-tall') === '1');
          main.hidden = true; mainVid.hidden = false; main.parentNode.classList.add('is-vid');
          if (ovlEl) ovlEl.hidden = true;
          // the tap is the visitor's own gesture, so start with sound; muted if the browser still says no
          mainVid.muted = false;
          var pr = mainVid.play();
          if (pr && pr.catch) pr.catch(function () {
            mainVid.muted = true;
            var p2 = mainVid.play(); if (p2 && p2.catch) p2.catch(function () {});
          });
          all('.gk-p2-thumb', root).forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          showThumb(btn);
        });
      });
    }
    // Thumbnail row: every photo, scrolling sideways; chevrons + edge fade only on the side with more.
    var tstrip = root && root.querySelector('[data-gk-thumbs]');
    var showThumb = function (b) {
      if (!tstrip || !b) return;
      var x = b.offsetLeft, w = b.offsetWidth, v = tstrip.scrollLeft, cw = tstrip.clientWidth;
      if (x < v + 8 || x + w > v + cw - 8) tstrip.scrollTo({left: x - (cw - w) / 2, behavior: 'smooth'});
    };
    if (tstrip) {
      var twrap = tstrip.parentNode;
      var tL = twrap.querySelector('[data-gk-thumbmore="-1"]'), tR = twrap.querySelector('[data-gk-thumbmore="1"]');
      var tsync = function () {
        var max = tstrip.scrollWidth - tstrip.clientWidth, l = tstrip.scrollLeft > 4, r = tstrip.scrollLeft < max - 4;
        twrap.classList.toggle('is-l', l); twrap.classList.toggle('is-r', r);
        if (tL) tL.hidden = !l;
        if (tR) tR.hidden = !r;
      };
      [tL, tR].forEach(function (m) {
        if (!m) return;
        m.addEventListener('click', function () {
          tstrip.scrollBy({left: Number(m.getAttribute('data-gk-thumbmore')) * tstrip.clientWidth * 0.7, behavior: 'smooth'});
        });
      });
      tstrip.addEventListener('scroll', tsync, {passive: true});
      window.addEventListener('resize', tsync);
      window.addEventListener('load', tsync);
      tsync();
    }

    /* ---------- 2. Complete the kit: running total + add everything in one go ---------- */
    /* The Christmas Club link is rebuilt whenever the kit changes, so ticked extras travel with the
       ride. Declared here because the kit (module 2) runs before the Club wiring (module 3). */
    var clubSync = function () {};
    var stickyPrice = root && root.querySelector('[data-gk-sticky-price]');
    var kit = root && root.querySelector('[data-gk-kit]');
    var recalc = function () {};
    if (kit) {
      var totalLabel = kit.querySelector('[data-gk-kit-label]');
      var totalValue = kit.querySelector('[data-gk-kit-value]');
      var addonNote = root.querySelector('[data-gk-addon-note]');
      recalc = function () {
        var basePence = parseInt(kit.getAttribute('data-base-price') || '0', 10);
        var baseAvailable = kit.getAttribute('data-base-available') === 'true';
        var picked = all('input[type=checkbox]', kit).filter(function (c) { return c.checked; });
        var addons = picked.reduce(function (sum, c) { return sum + parseInt(c.getAttribute('data-price') || '0', 10); }, 0);
        var n = picked.length;
        // Light up the whole row so a ticked add-on is unmistakable, not just a small box.
        all('[data-gk-kit-item]', kit).forEach(function (r) {
          var b = r.querySelector('input[type=checkbox]');
          r.classList.toggle('is-picked', !!(b && b.checked));
        });
        if (totalLabel) totalLabel.textContent = n ? 'This ride + ' + n + ' accessor' + (n > 1 ? 'ies' : 'y') : 'Just this ride';
        // Out of stock: the ride cannot be bought, so only the accessories total.
        var shown = baseAvailable ? basePence + addons : (n ? addons : basePence);
        if (totalValue) totalValue.textContent = money(shown, moneyFormat);
        if (stickyPrice) stickyPrice.textContent = money(shown, moneyFormat);
        // The button sits above the kit now, so it shows the running total once an add-on is ticked.
        var ctaTotal = root.querySelector('[data-gk-cta-total]');
        if (ctaTotal) ctaTotal.textContent = (n && baseAvailable) ? ' — ' + money(shown, moneyFormat) : '';
        if (addonNote) {
          addonNote.hidden = !(n > 0 && !baseAvailable);
          var amt = addonNote.querySelector('[data-gk-addon-amount]');
          if (amt) amt.textContent = money(addons, moneyFormat);
        }
        clubSync();
      };
      all('input[type=checkbox]', kit).forEach(function (c) { c.addEventListener('change', recalc); });
      recalc();

      /* Add-on colour lightbox — same shell as the product-film one, so picking a colour opens a
         proper look at it with Previous/Next through the colours and an Add-to-kit button. */
      var kb = document.querySelector('[data-gk-kb]');
      var kbCtx = null;
      var kbClose = function () {
        if (!kb) return;
        kb.classList.remove('gk-lb-on');
        setTimeout(function () { kb.hidden = true; }, 160);
        if (openOverlay && openOverlay.el === kb) openOverlay = null;
        if (kbCtx && kbCtx.origin) kbCtx.origin.focus();
      };
      var kbPaint = function () {
        if (!kb || !kbCtx) return;
        var m = kbCtx.match();
        kb.querySelector('[data-gk-kb-label]').textContent = kbCtx.name;
        kb.querySelector('[data-gk-kb-count]').textContent = kbCtx.values.length > 1 ?
          kbCtx.optName + ' ' + (kbCtx.index() + 1) + ' of ' + kbCtx.values.length : '';
        var kbNav = kb.querySelector('.gk-lb-nav');
        if (kbNav) kbNav.hidden = kbCtx.values.length < 2;
        var im = kb.querySelector('[data-gk-kb-img]');
        var src = m && (m.imgL || m.img);
        if (src) { im.src = src; im.hidden = false; } else { im.hidden = true; }
        kb.querySelector('[data-gk-kb-opts]').textContent = kbCtx.chosenText();
        kb.querySelector('[data-gk-kb-price]').textContent = m ? money(m.p, moneyFormat) : '';
        var de = kb.querySelector('[data-gk-kb-desc]');
        de.textContent = kbCtx.desc || '';
        de.hidden = !kbCtx.desc;
        var mo = kb.querySelector('[data-gk-kb-more]');
        if (kbCtx.url) { mo.href = kbCtx.url; mo.hidden = false; } else { mo.hidden = true; }
        var st = kb.querySelector('[data-gk-kb-stock]');
        if (m && !m.a) {
          st.hidden = false; st.className = 'gk-kb-stock gk-kb-stock-out';
          st.textContent = 'Sold out in this combination';
        } else if (m && m.q > 0 && m.q <= 5) {
          st.hidden = false; st.className = 'gk-kb-stock gk-kb-stock-low';
          st.textContent = 'Only ' + m.q + ' left';
        } else if (m) {
          st.hidden = false; st.className = 'gk-kb-stock gk-kb-stock-in';
          st.textContent = 'In stock';
        } else { st.hidden = true; }
        var add = kb.querySelector('[data-gk-kb-add]');
        add.disabled = !(m && m.a);
        add.textContent = kbCtx.isTicked() ? 'In your kit ✓' : 'Add to kit';
      };
      var kbOpen = function (ctx, origin) {
        if (!kb) return;
        kbCtx = ctx; kbCtx.origin = origin;
        kb.hidden = false;
        requestAnimationFrame(function () { kb.classList.add('gk-lb-on'); });
        kbPaint();
        openOverlay = {el: kb, panel: kb.querySelector('.gk-lb-panel'), close: kbClose, onKey: function (e) {
          if (e.key === 'ArrowRight') { kbCtx.step(1); kbPaint(); }
          if (e.key === 'ArrowLeft') { kbCtx.step(-1); kbPaint(); }
        }};
        var c = kb.querySelector('.gk-lb-close'); if (c) c.focus();
      };
      if (kb) {
        all('[data-gk-kb-close]', kb).forEach(function (b) { b.addEventListener('click', kbClose); });
        kb.querySelector('[data-gk-kb-prev]').addEventListener('click', function () { if (kbCtx) { kbCtx.step(-1); kbPaint(); } });
        kb.querySelector('[data-gk-kb-next]').addEventListener('click', function () { if (kbCtx) { kbCtx.step(1); kbPaint(); } });
        kb.querySelector('[data-gk-kb-add]').addEventListener('click', function () {
          if (kbCtx) { kbCtx.tick(); kbPaint(); kbClose(); }
        });
      }

      /* Add-on colour / size pills. The row prices and pictures ONE variant, so picking a colour has to
         move the checkbox's variant id, its price, the row photo and the running total together —
         otherwise someone ticks "Red" and a yellow helmet lands in the cart. A value is greyed out when
         no in-stock variant exists for it alongside the other choices. */
      all('[data-gk-kit-item]', kit).forEach(function (row) {
        var variants = parseJSON(row.querySelector('[data-gk-kit-variants]'));
        if (!variants || !variants.length) return;
        var box = row.querySelector('input[type=checkbox]');
        var img = row.querySelector('[data-gk-kit-img]');
        var priceEl = row.querySelector('[data-gk-kit-rowprice]');
        var groups = all('[data-gk-kit-opt]', row);
        var chosen = groups.map(function (g) {
          var on = g.querySelector('.gk-p2-kit-pill.is-on');
          return on ? on.getAttribute('data-gk-kit-val') : null;
        });
        var find = function (sel) {
          for (var i = 0; i < variants.length; i++) {
            var ok = true;
            for (var j = 0; j < sel.length; j++) if (sel[j] !== null && variants[i].o[j] !== sel[j]) { ok = false; break; }
            if (ok) return variants[i];
          }
          return null;
        };
        var findAvailable = function (sel) {
          for (var i = 0; i < variants.length; i++) {
            if (!variants[i].a) continue;
            var ok = true;
            for (var j = 0; j < sel.length; j++) if (sel[j] !== null && variants[i].o[j] !== sel[j]) { ok = false; break; }
            if (ok) return variants[i];
          }
          return null;
        };
        var showBox = function (gi) {
          var g = groups[gi];
          var pills = all('.gk-p2-kit-pill', g);
          var vals = pills.map(function (x) { return x.getAttribute('data-gk-kit-val'); });
          var lbl = (pills[0] && pills[0].getAttribute('aria-label')) || '';
          var nameEl = row.querySelector('.gk-p2-kit-name');
          kbOpen({
            name: nameEl ? nameEl.textContent.trim() : '',
            desc: row.getAttribute('data-gk-kit-desc') || '',
            url: row.getAttribute('data-gk-kit-url') || '',
            optName: lbl.indexOf(':') > 0 ? lbl.split(':')[0].trim() : 'Option',
            values: vals,
            index: function () { return vals.indexOf(chosen[gi]); },
            match: function () { return findAvailable(chosen) || find(chosen); },
            chosenText: function () { return chosen.filter(Boolean).join(' · '); },
            isTicked: function () { return !!(box && box.checked); },
            tick: function () { if (box && !box.disabled) { box.checked = true; recalc(); } },
            step: function (d) {
              var i = vals.indexOf(chosen[gi]);
              chosen[gi] = vals[(i + d + vals.length) % vals.length];
              apply();
            }
          }, pills[Math.max(0, vals.indexOf(chosen[gi]))]);
        };
        var apply = function () {
          var match = findAvailable(chosen) || find(chosen);
          if (match) {
            box.setAttribute('data-variant', match.id);
            box.setAttribute('data-price', match.p);
            box.setAttribute('data-sku', match.s || '');
            // A combination that is out of stock must not stay ticked, or the total would include
            // something the cart will refuse.
            if (!match.a && box.checked) box.checked = false;
            box.disabled = !match.a;
            if (priceEl) priceEl.textContent = money(match.p, moneyFormat);
            if (img && match.img) img.src = match.img;
            row.classList.toggle('is-sold-out', !match.a);
          }
          // Name the chosen options in words — a swatch alone doesn't say "Red", and it has to be
          // readable to someone who can't tell the circles apart.
          var chosenEl = row.querySelector('[data-gk-kit-chosen]');
          if (chosenEl) chosenEl.textContent = chosen.filter(Boolean).join(' · ');
          // Grey out any value with no in-stock combination alongside the current picks.
          groups.forEach(function (g, gi) {
            all('.gk-p2-kit-pill', g).forEach(function (pill) {
              var val = pill.getAttribute('data-gk-kit-val');
              var test = chosen.slice();
              test[gi] = val;
              for (var k = 0; k < test.length; k++) if (k !== gi && !findAvailable(test)) test[k] = null;
              var ok = !!findAvailable(test);
              pill.classList.toggle('is-off', !ok);
              pill.classList.toggle('is-on', chosen[gi] === val);
              pill.setAttribute('aria-pressed', chosen[gi] === val ? 'true' : 'false');
            });
          });
          recalc();
        };
        groups.forEach(function (g, gi) {
          all('.gk-p2-kit-pill', g).forEach(function (pill) {
            pill.addEventListener('click', function (e) {
              e.preventDefault();
              chosen[gi] = pill.getAttribute('data-gk-kit-val');
              showBox(gi);
              apply();
            });
          });
        });
        apply();
      });

      /* "Details ›" on every add-on row opens the same preview panel the colour pills use, so an
         accessory with no options (a bag, a carry handle) can be looked at before it is ticked.
         Rows with options reuse the pill flow at the current choice; single-variant rows build a
         one-entry context and the panel hides its previous/next buttons. */
      all('[data-gk-kit-item]', kit).forEach(function (row) {
        var trig = row.querySelector('[data-gk-kit-info]');
        if (!trig) return;
        trig.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          var pill = row.querySelector('[data-gk-kit-opt] .gk-p2-kit-pill.is-on') ||
                     row.querySelector('[data-gk-kit-opt] .gk-p2-kit-pill');
          if (pill) { pill.click(); return; }
          var variants = parseJSON(row.querySelector('[data-gk-kit-variants]')) || [];
          var m = variants[0] || null;
          var box = row.querySelector('input[type=checkbox]');
          var nameEl = row.querySelector('.gk-p2-kit-name');
          kbOpen({
            name: nameEl ? nameEl.textContent.trim() : '',
            desc: row.getAttribute('data-gk-kit-desc') || '',
            url: row.getAttribute('data-gk-kit-url') || '',
            optName: '', values: [],
            index: function () { return 0; },
            match: function () { return m; },
            chosenText: function () { return ''; },
            isTicked: function () { return !!(box && box.checked); },
            tick: function () { if (box && !box.disabled) { box.checked = true; recalc(); } },
            step: function () {}
          }, trig);
        });
      });

      /* The theme's product form posts a single variant. To add the ride AND the ticked
         accessories in one go we post them all to /cart/add.js, then go to the cart. */
      var form = root.querySelector('form[action*="/cart/add"]');
      var submitAll = function (e, includeBase) {
        var picked = all('input[type=checkbox]', kit).filter(function (c) { return c.checked; });
        e.preventDefault();
        var items = [];
        if (includeBase && form) {
          var idInput = form.querySelector('[name="id"]');
          var qtyInput = form.querySelector('[name="quantity"]');
          if (idInput && idInput.value) items.push({id: Number(idInput.value), quantity: Number((qtyInput && qtyInput.value) || 1)});
        }
        picked.forEach(function (c) { items.push({id: Number(c.getAttribute('data-variant')), quantity: 1}); });
        gkAddToCart(items, e.currentTarget, includeBase ? form : null);
      };
      var ctaBtn = root.querySelector('button[data-gk-cta]');
      if (ctaBtn) ctaBtn.addEventListener('click', function (e) { submitAll(e, true); });
      var addonsOnly = root.querySelector('[data-gk-addons-only]');
      if (addonsOnly) addonsOnly.addEventListener('click', function (e) { submitAll(e, false); });
    }

    /* A product with no "Complete the kit" block never reached the handler above,
       so its Add to cart stayed a plain form POST straight through to /cart. */
    if (!kit) {
      var plainForm = root && root.querySelector('form[action*="/cart/add"]');
      var plainCta = root && root.querySelector('button[data-gk-cta]');
      if (plainForm && plainCta) {
        plainCta.addEventListener('click', function (e) {
          var idInput = plainForm.querySelector('[name="id"]');
          var qtyInput = plainForm.querySelector('[name="quantity"]');
          if (!idInput || !idInput.value) return;   /* let the form speak for itself */
          e.preventDefault();
          gkAddToCart([{
            id: Number(idInput.value),
            quantity: Number((qtyInput && qtyInput.value) || 1),
          }], plainCta, plainForm);
        });
      }
    }

    /* ---------- 3. Christmas Club link carries the selected variant's SKU ---------- */
    var clubLink = root && root.querySelector('[data-gk-club-link]');
    var clubSkus = parseJSON(root && root.querySelector('[data-gk-club-skus]')) || {};
    var clubBase = clubLink ? clubLink.getAttribute('href').split('?')[0] : '';
    var clubExtras = root && root.querySelector('[data-gk-club-extras]');
    /* The Club's /join accepts a comma-separated sku list and adds each one it can find in Odoo to the
       basket, so the ticked accessories can ride along with the product. A variant with no SKU (or one
       Odoo doesn't stock) is simply left out — /join skips what it cannot match. */
    clubSync = function () {
      if (!clubLink) return;
      var idInput = root.querySelector('form[action*="/cart/add"] [name="id"]');
      var skus = [];
      var mainSku = idInput && clubSkus[idInput.value];
      if (mainSku) skus.push(mainSku);
      var extras = kit
        ? all('input[type=checkbox]', kit).filter(function (c) { return c.checked && c.getAttribute('data-sku'); })
        : [];
      extras.forEach(function (c) { skus.push(c.getAttribute('data-sku')); });
      if (skus.length) clubLink.href = clubBase + '?sku=' + encodeURIComponent(skus.join(','));
      if (clubExtras) {
        var n = extras.length;
        clubExtras.hidden = n === 0;
        clubExtras.textContent = n
          ? 'Your ' + n + ' ticked extra' + (n > 1 ? 's come' : ' comes') + ' with it'
          : '';
      }
    };
    if (clubLink) { clubLink.addEventListener('click', clubSync); clubSync(); }

    /* ---------- 4. Drawers (information + rider fit) share one open/close ---------- */
    var makeDrawer = function (drawer) {
      var panel = drawer.querySelector('.gk-fitd-panel');
      var closeBtn = drawer.querySelector('[data-gk-drawer-close]');
      var scrim = drawer.querySelector('[data-gk-scrim]');
      var lastTrigger = null;
      var api = {
        open: function (trigger) {
          lastTrigger = trigger || null;
          drawer.classList.add('gk-fitd-on');
          drawer.setAttribute('aria-hidden', 'false');
          lockScroll(true);
          openOverlay = {el: drawer, panel: panel, close: api.close};
          if (closeBtn) closeBtn.focus();
        },
        close: function () {
          drawer.classList.remove('gk-fitd-on');
          drawer.setAttribute('aria-hidden', 'true');
          lockScroll(false);
          if (openOverlay && openOverlay.el === drawer) openOverlay = null;
          if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
        },
      };
      if (closeBtn) closeBtn.addEventListener('click', api.close);
      if (scrim) scrim.addEventListener('click', api.close);
      return api;
    };

    var infoDrawerEl = root && root.querySelector('[data-gk-drawer]');
    if (infoDrawerEl) {
      var info = makeDrawer(infoDrawerEl);
      var titleEl = infoDrawerEl.querySelector('[data-gk-drawer-title]');
      var eyebrowEl = infoDrawerEl.querySelector('[data-gk-drawer-eyebrow]');
      var bodyEl = infoDrawerEl.querySelector('[data-gk-drawer-body]');
      all('[data-gk-open]', root).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var src = root.querySelector('#' + btn.getAttribute('data-gk-open'));
          if (!src) return;
          if (eyebrowEl) eyebrowEl.textContent = src.getAttribute('data-eyebrow') || '';
          if (titleEl) titleEl.textContent = src.getAttribute('data-title') || '';
          if (bodyEl) bodyEl.innerHTML = src.innerHTML;
          info.open(btn);
        });
      });
    }

    /* ---------- 5. Rider fit drawer: true-scale ruler, child figure and verdict ---------- */
    var fitEl = root && root.querySelector('[data-gk-fitd]');
    if (fitEl) {
      var fit = makeDrawer(fitEl);
      var RULER_MAX = 190;
      var fitMin = Number(fitEl.getAttribute('data-min')) || 0;
      var fitMax = Number(fitEl.getAttribute('data-max')) || 0;
      var figs = parseJSON(fitEl.querySelector('[data-gk-figs]')) || [];
      var range = fitEl.querySelector('[data-gk-fit-range]');
      var kid = fitEl.querySelector('[data-gk-fit-kid]');
      var marker = fitEl.querySelector('[data-gk-fit-marker]');
      var markerLabel = fitEl.querySelector('[data-gk-fit-marker-label]');
      var verdict = fitEl.querySelector('[data-gk-fit-verdict]');
      var pct = function (cm) { return (cm / RULER_MAX) * 100; };
      var figureFor = function (cm) {
        var f = null;
        for (var i = 0; i < figs.length; i++) { if (cm < figs[i].max) { f = figs[i]; break; } }
        if (!f) f = figs[figs.length - 1];
        if (!f) return null;
        var box = pct(cm) / (f.content / 100); // scale up for the transparent dead space
        return {src: f.src, box: box, bottom: -(f.padBot / 100) * box}; // then sink the gap below the floor
      };
      var fitPhone = fitEl.getAttribute('data-phone') || '028 8731 2118';
      var verdictFor = function (cm) {
        if (!fitMin || !fitMax) return {tone: 'edge', line: 'We haven’t published a height range for the ' + name + ' yet — ring Andy on ' + fitPhone + ' with ' + cm + 'cm and he’ll tell you straight.'};
        if (cm < fitMin - 10) return {tone: 'no', line: 'The ' + name + ' is too big for them yet — ring us and we’ll point you at the right size.'};
        if (cm < fitMin) return {tone: 'edge', line: 'Just under the range — they may manage it, but ring us before you buy.'};
        if (cm <= fitMax) return {tone: 'yes', line: 'Good fit — the ' + name + ' is built for this height.'};
        if (cm <= fitMax + 10) return {tone: 'edge', line: 'Near the top of the range — fine now, but they will grow out of it.'};
        return {tone: 'no', line: 'They have outgrown the ' + name + ' — ring us for the next size up.'};
      };
      var updateFit = function () {
        if (!range) return;
        var cm = Number(range.value);
        var f = figureFor(cm);
        if (kid && f) {
          if (kid.getAttribute('src') !== f.src) kid.src = f.src;
          kid.style.height = f.box + '%';
          kid.style.bottom = f.bottom + '%';
        }
        if (marker) marker.style.bottom = pct(cm) + '%';
        if (markerLabel) markerLabel.textContent = cm + 'cm';
        var vd = verdictFor(cm);
        if (verdict) {
          verdict.className = 'gk-fitd-verdict gk-p2-fit-' + vd.tone;
          verdict.textContent = vd.line;
        }
      };
      if (range) range.addEventListener('input', updateFit);
      updateFit();
      all('[data-gk-fit-open]', root).forEach(function (btn) {
        btn.addEventListener('click', function () { fit.open(btn); });
      });
    }

    /* ---------- 6. "Know who you're buying from" peek panel ---------- */
    all('[data-gk-peek]', scope).forEach(function (pk) {
      var head = pk.querySelector('[data-gk-peek-toggle]');
      var body = pk.querySelector('.gk-peek-body');
      var inner = pk.querySelector('.gk-peek-inner');
      if (!head || !body || !inner) return;
      var through = pk.getAttribute('data-peek-through');
      var slice = Number(pk.getAttribute('data-peek-slice')) || 46;
      var open = false, everOpened = false, inView = false;
      var measure = function () {
        var h = inner.offsetHeight;
        var peekH = 0;
        if (through) {
          var t = inner.querySelector(through);
          if (t) peekH = Math.round(t.getBoundingClientRect().top - inner.getBoundingClientRect().top + slice);
        }
        body.style.height = (open ? h : Math.min(peekH || h, h)) + 'px';
      };
      head.addEventListener('click', function () {
        open = !open; everOpened = true;
        pk.classList.toggle('gk-peek-open', open);
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
        measure();
      });
      measure();
      if ('ResizeObserver' in window) new ResizeObserver(measure).observe(inner);
      all('img', inner).forEach(function (im) { im.addEventListener('load', measure); });
      window.addEventListener('load', measure);
      // The stylesheet can land after this script on a slow connection; re-measure once it has.
      setTimeout(measure, 400); setTimeout(measure, 1500); setTimeout(measure, 4000);
      // A gentle repeated nudge while it is on screen and still shut; stops for good once opened.
      if (!reduce && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { inView = en[0].isIntersecting; }, {threshold: 0.9}).observe(pk);
        setInterval(function () {
          if (!inView || open || everOpened) return;
          pk.classList.add('gk-peek-nudge');
          setTimeout(function () { pk.classList.remove('gk-peek-nudge'); }, 700);
        }, 4200);
      }
    });

    /* ---------- 7. Trust rotator ---------- */
    all('[data-gk-trustrot]', scope).forEach(function (tr) {
      var items = all('li', tr);
      if (items.length < 2 || reduce) return;
      tr.classList.add('gk-trustrot-live');
      var i = 0, paused = false;
      items.forEach(function (li, n) { li.classList.toggle('is-on', n === 0); });
      tr.addEventListener('mouseenter', function () { paused = true; });
      tr.addEventListener('mouseleave', function () { paused = false; });
      setInterval(function () {
        if (paused) return;
        i = (i + 1) % items.length;
        items.forEach(function (li, n) { li.classList.toggle('is-on', n === i); });
      }, 3400);
    });

    /* ---------- 8. Product films → lightbox ---------- */
    var lb = document.querySelector('[data-gk-lb]');
    var reels = all('[data-gk-reel]', scope);
    if (lb && reels.length) {
      var lbVideo = lb.querySelector('[data-gk-lb-video]');
      var lbLabel = lb.querySelector('[data-gk-lb-label]');
      var lbCount = lb.querySelector('[data-gk-lb-count]');
      var lbIndex = -1, lbTrigger = null;
      var showReel = function (i) {
        lbIndex = (i + reels.length) % reels.length;
        var r = reels[lbIndex];
        if (lbVideo) {
          lbVideo.poster = r.getAttribute('data-poster') || '';
          lbVideo.src = r.getAttribute('data-src');
          lbVideo.muted = true;
          lbVideo.play().catch(function () {});
        }
        if (lbLabel) lbLabel.textContent = r.getAttribute('data-label') || '';
        if (lbCount) lbCount.textContent = 'Product film ' + (lbIndex + 1) + ' of ' + reels.length;
      };
      var closeLb = function () {
        lb.hidden = true;
        lb.classList.remove('gk-lb-on');
        if (lbVideo) { lbVideo.pause(); lbVideo.removeAttribute('src'); lbVideo.load(); }
        lockScroll(false);
        openOverlay = null;
        if (lbTrigger) lbTrigger.focus();
      };
      var openLb = function (i, trigger) {
        lbTrigger = trigger || null;
        lb.hidden = false;
        lb.classList.add('gk-lb-on');
        showReel(i);
        lockScroll(true);
        openOverlay = {el: lb, panel: lb.querySelector('.gk-lb-panel'), close: closeLb, onKey: function (e) {
          if (e.key === 'ArrowRight') showReel(lbIndex + 1);
          if (e.key === 'ArrowLeft') showReel(lbIndex - 1);
        }};
        var c = lb.querySelector('.gk-lb-close');
        if (c) c.focus();
      };
      reels.forEach(function (r, i) { r.addEventListener('click', function () { openLb(i, r); }); });
      all('[data-gk-lb-close]', lb).forEach(function (b) { b.addEventListener('click', closeLb); });
      var prevB = lb.querySelector('[data-gk-lb-prev]'), nextB = lb.querySelector('[data-gk-lb-next]');
      if (prevB) prevB.addEventListener('click', function () { showReel(lbIndex - 1); });
      if (nextB) nextB.addEventListener('click', function () { showReel(lbIndex + 1); });
      if (reels.length < 2) { var nav = lb.querySelector('.gk-lb-nav'); if (nav) nav.hidden = true; }
    }

    /* ---------- 9. Sticky buy bar ---------- */
    var bar = root && root.querySelector('[data-gk-sticky]');
    var cta = root && root.querySelector('[data-gk-cta]');
    if (bar && cta && 'IntersectionObserver' in window) {
      var barCta = bar.querySelector('[data-gk-sticky-cta]');
      new IntersectionObserver(function (en) {
        var e = en[0];
        var on = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('gk-p2-sticky-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        all('a, button', bar).forEach(function (b) { b.tabIndex = on ? 0 : -1; });
      }, {threshold: 0}).observe(root.querySelector('.gk-pdp-price') || cta); // appears once the PRICE scrolls away, not the button (16 Sep 2026)
      if (barCta) barCta.addEventListener('click', function () {
        if (cta.tagName === 'BUTTON') cta.click();
        else if (cta.href) window.location.href = cta.href;
      });
    }

    /* ---------- 10. Variant selects -> hidden id, price, stock, club link ---------- */
    (function () {
      if (!root) return;
      var wrap = root.querySelector('[data-gk-variants]');
      if (!wrap) return;
      var variants = parseJSON(wrap);
      if (!variants) return;
      var selects = all('[data-gk-option]', root);
      var idInput = root.querySelector('form[action*="/cart/add"] [name="id"]');
      var priceEl = root.querySelector('.gk-pdp-price');
      var stickyStock = root.querySelector('[data-gk-sticky-stock]');
      var apply = function () {
        var chosen = selects.map(function (s) { return s.value; });
        var match = null;
        for (var i = 0; i < variants.length; i++) {
          var ok = true;
          for (var j = 0; j < chosen.length; j++) if (variants[i].opts[j] !== chosen[j]) { ok = false; break; }
          if (ok) { match = variants[i]; break; }
        }
        if (!match) return;
        if (idInput) idInput.value = match.id;
        /* selecting a colour must move the gallery to that colour's photo */
        if (match.img && main && main.getAttribute('src') !== match.img) {
          if (typeof showImg === 'function') showImg();
          main.src = match.img;
          if (match.imgalt) main.alt = match.imgalt;
          all('.gk-p2-thumb', root).forEach(function (b) {
            b.classList.toggle('is-active', b.getAttribute('data-gk-thumb') === match.img);
            if (b.getAttribute('data-gk-thumb') === match.img) showThumb(b);
          });
          if (typeof applyOverlay === 'function') applyOverlay(match.imgsrc || '');
        }
        if (priceEl && priceEl.firstChild) priceEl.firstChild.nodeValue = money(match.price, moneyFormat) + ' ';
        if (kit) {
          kit.setAttribute('data-base-price', match.price);
          kit.setAttribute('data-base-available', match.available ? 'true' : 'false');
        }
        recalc();
        if (!kit && stickyPrice) stickyPrice.textContent = money(match.price, moneyFormat);
        var stock = root.querySelector('.gk-pdp-stock');
        if (stock) {
          stock.classList.toggle('gk-pdp-instock', match.available);
          stock.classList.toggle('gk-pdp-oos', !match.available);
          stock.textContent = match.available ? '● In stock — ready to ship' : '● Back soon — more on the way';
        }
        if (stickyStock) stickyStock.textContent = match.available ? 'In stock' : 'Back soon';
        clubSync();
      };
      selects.forEach(function (s) { s.addEventListener('change', apply); });

      /* picture swatches drive the (hidden) selects, so variant/price/stock logic stays in one place */
      var swatches = all('[data-gk-swatch]', root);
      var syncSwatches = function () {
        selects.forEach(function (sel, i) {
          var lab = root.querySelector('[data-gk-optval="' + i + '"]');
          if (lab) lab.textContent = sel.value;
          swatches.forEach(function (b) {
            if (+b.getAttribute('data-gk-swatch') !== i) return;
            var on = b.getAttribute('data-val') === sel.value;
            b.classList.toggle('is-on', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
        });
      };
      swatches.forEach(function (b) {
        b.addEventListener('click', function () {
          var i = +b.getAttribute('data-gk-swatch');
          var sel = selects[i];
          if (!sel || sel.value === b.getAttribute('data-val')) return;
          sel.value = b.getAttribute('data-val');
          apply();
          syncSwatches();
        });
      });
      syncSwatches();
    })();


    /* ---------- 11. Tread marks: laid down by scroll position (these live in the lower section) ---------- */
    all('[data-gk-tmarks]', document).forEach(function (host) {
      var sec = host.parentElement;
      var marks = all('.gk-tmark', host);
      if (!marks.length) return;
      if (reduce) { marks.forEach(function (m) { m.style.setProperty('--p', '1'); }); return; }
      var last = 0;
      var update = function () {
        var r = sec.getBoundingClientRect();
        var vh = window.innerHeight;
        var p = (vh - r.top) / (vh * 0.85 + r.height * 0.5);
        var clamped = Math.max(0, Math.min(1, p));
        marks.forEach(function (m) {
          var s = Number(m.getAttribute('data-start') || 0);
          var own = (clamped - s) / (1 - s || 1);
          m.style.setProperty('--p', String(Math.max(0, Math.min(1, own))));
        });
      };
      var onScroll = function () {
        var now = performance.now();
        if (now - last < 16) return;
        last = now;
        update();
      };
      update();
      window.addEventListener('scroll', onScroll, {passive: true});
      window.addEventListener('resize', onScroll);
    });

    /* ---------- 12. Part callouts: dots open a popover beside the part ---------- */
    all('[data-gk-diagram]', document).forEach(function (dg) {
      var dots = all('[data-gk-dot]', dg);
      var pops = all('[data-gk-pop]', dg);
      var closeAll = function () {
        pops.forEach(function (p) { p.hidden = true; });
        dots.forEach(function (d) { d.classList.remove('gk-p2-dot-on'); d.setAttribute('aria-expanded', 'false'); });
      };
      dots.forEach(function (d) {
        d.addEventListener('click', function (e) {
          e.stopPropagation();
          var id = d.getAttribute('data-gk-dot');
          var pop = dg.querySelector('[data-gk-pop="' + id + '"]');
          var wasOpen = pop && !pop.hidden;
          closeAll();
          if (pop && !wasOpen) { pop.hidden = false; d.classList.add('gk-p2-dot-on'); d.setAttribute('aria-expanded', 'true'); }
        });
      });
      all('[data-gk-pop-close]', dg).forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); closeAll(); }); });
      pops.forEach(function (p) { p.addEventListener('click', function (e) { e.stopPropagation(); }); });
      document.addEventListener('click', function (e) { if (!dg.contains(e.target)) closeAll(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    });

    /* ---------- 13. Specification tabs ---------- */
    all('[data-gk-tabs]', document).forEach(function (tabs) {
      var list = tabs.querySelector('[data-gk-tablist]');
      var wrap = tabs.querySelector('[data-gk-tabwrap]');
      var body = tabs.querySelector('[data-gk-tabbody]');
      var btns = all('[data-gk-tab]', tabs);
      var panels = all('[data-gk-tabpanel]', tabs);
      if (!list || !btns.length) return;
      var ro = null;
      var setHeight = function () {
        var p = panels.filter(function (x) { return !x.hidden; })[0];
        if (!p || !body) return;
        body.style.height = p.offsetHeight + 'px';
        if ('ResizeObserver' in window) {
          if (ro) ro.disconnect();
          ro = new ResizeObserver(function () { body.style.height = p.offsetHeight + 'px'; });
          ro.observe(p);
        }
      };
      var select = function (id, focus) {
        btns.forEach(function (b) {
          var on = b.getAttribute('data-gk-tab') === id;
          b.classList.toggle('gk-p2-tab-on', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
          if (on) { b.scrollIntoView({block: 'nearest', inline: 'nearest'}); if (focus) b.focus(); }
        });
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-gk-tabpanel') !== id; });
        setHeight();
      };
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () { select(b.getAttribute('data-gk-tab')); });
        b.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          var next = btns[(i + d + btns.length) % btns.length];
          select(next.getAttribute('data-gk-tab'), true);
        });
      });
      // Fades + chevrons only on the side that still has more strip to scroll to.
      var moreL = tabs.querySelector('[data-gk-tabmore="-1"]');
      var moreR = tabs.querySelector('[data-gk-tabmore="1"]');
      var sync = function () {
        var max = list.scrollWidth - list.clientWidth;
        var l = list.scrollLeft > 4, r = list.scrollLeft < max - 4;
        if (wrap) { wrap.classList.toggle('gk-p2-tabwrap-l', l); wrap.classList.toggle('gk-p2-tabwrap-r', r); }
        if (moreL) moreL.hidden = !l;
        if (moreR) moreR.hidden = !r;
      };
      [moreL, moreR].forEach(function (m) {
        if (!m) return;
        m.addEventListener('click', function () {
          list.scrollBy({left: Number(m.getAttribute('data-gk-tabmore')) * list.clientWidth * 0.6, behavior: 'smooth'});
        });
      });
      list.addEventListener('scroll', sync, {passive: true});
      window.addEventListener('resize', function () { sync(); setHeight(); });
      sync();
      window.addEventListener('load', setHeight);
      setHeight();
    });

    /* ---------- 14. Ambient videos: play when on screen, pause when not ---------- */
    // Ambient clips carry data-gk-ambient and NO autoplay attribute, so nothing is fetched until
    // they scroll into view and we call play() — 8 videos preloading at once made the page crawl.
    var vids = all('.gk-pdp video[autoplay], .gk-pdp video[data-gk-ambient]');
    vids.forEach(function (v) { v.muted = true; v.setAttribute('muted', ''); });
    if ('IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
          else v.pause();
        });
      }, {threshold: 0.1});
      vids.forEach(function (v) { vio.observe(v); });
    } else {
      vids.forEach(function (v) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); });
    }

    /* ---------- 16. Reviews: one rating line above the fold, one review block below ----------
       Judge.me renders its widgets asynchronously, so we poll for a short while rather than watch
       the DOM. An earlier version used a MutationObserver with `attributes: true` on the very node
       this code sets `hidden` on — each write re-triggered the observer, which wrote again, and the
       main thread never came back (Firefox: "this page is slowing down"). Never observe a subtree
       you also mutate; a bounded poll is enough for a widget that renders once. */
    (function () {
      var storeLine = root && root.querySelector('.gk-pdp-stars');
      var quotes = document.querySelector('[data-gk-quotes]');
      var block = document.querySelector('.gk-p2-appblock');
      var quotesAlways = quotes && quotes.getAttribute('data-always') === 'true';
      var last = '';
      var tries = 0;
      var set = function (el, hide) { if (el && el.hidden !== hide) el.hidden = hide; };
      var sync = function () {
        var badge = block && block.querySelector('.jdgm-prev-badge');
        var n = badge ? parseInt(badge.getAttribute('data-number-of-reviews') || '0', 10) : 0;
        var widg = document.querySelector('.jdgm-rev-widg');
        var wn = widg ? parseInt(widg.getAttribute('data-number-of-reviews') || '0', 10) : 0;
        var live = document.querySelector('[data-gk-jdgm-live]');
        var liveOn = !!(live && live.children.length);
        var state = n + '|' + wn + '|' + liveOn + '|' + !!badge + '|' + !!widg;
        if (state !== last) {
          last = state;
          // Under 20 reviews of its own, a product shows the store-wide line ("5-star store rating · 70
          // verified reviews") instead of its own small count; Andy, 14 Oct: "only 3 reviews looks bad".
          var own = n >= 20;
          set(storeLine, own);
          set(block, !!badge && !own);
          if (quotes && !quotesAlways) set(quotes, wn > 0);
          if (liveOn) all('[data-gk-jdgm-fallback]').forEach(function (e) { set(e, true); });
        }
        // Poll for ~20s: fast while the widgets are still arriving, then stop for good.
        tries++;
        if (tries < 40) setTimeout(sync, tries < 10 ? 250 : 700);
      };
      sync();
    })();

    /* ---------- 15. Scroll reveal: fade-and-rise for blocks still below the fold ---------- */
    if (!reduce && 'IntersectionObserver' in window) {
      var targets = [];
      var sel = '.gk-p2-proof, .gk-p2-reels, .gk-assure, .gk-fitwrap, .gk-p2-tile, .gk-p2-story, .gk-p2-diagram, .gk-p2-tabs, .gk-visit-media, .gk-visit-body, .gk-pdp-rev, .gk-faq, .gk-pdp-tablewrap';
      all(sel, document).forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight * 0.9) return; // already in view: leave it
        el.classList.add('gk-rev');
        targets.push(el);
      });
      var heard = false;
      var io = new IntersectionObserver(function (entries) {
        heard = true;
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('gk-rev-on'); io.unobserve(e.target); }
        });
      }, {threshold: 0.12});
      targets.forEach(function (t) { io.observe(t); });
      // Safety net: if the observer never reports, show everything rather than leave it blank.
      setTimeout(function () { if (!heard) targets.forEach(function (t) { t.classList.add('gk-rev-on'); }); }, 900);
    }
  });
})();

// Story explainer pop-up (14 Oct 2026): the corner tile on a story picture plays its clip in a dialog, with sound.
(function () {
  var dlg = document.querySelector('[data-gk-pipdlg]');
  if (!dlg) return;
  var vid = dlg.querySelector('[data-gk-pipdlg-vid]'), title = dlg.querySelector('[data-gk-pipdlg-title]');
  var close = function () { vid.pause(); if (dlg.open) { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); } };
  Array.prototype.forEach.call(document.querySelectorAll('[data-gk-pip]'), function (btn) {
    btn.addEventListener('click', function () {
      var src = btn.getAttribute('data-gk-pip');
      if (vid.getAttribute('src') !== src) { vid.setAttribute('poster', btn.getAttribute('data-gk-pip-poster') || ''); vid.src = src; }
      title.textContent = btn.getAttribute('data-gk-pip-title') || '';
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      vid.currentTime = 0; vid.muted = false;
      var pr = vid.play();
      if (pr && pr.catch) pr.catch(function () { vid.muted = true; var p2 = vid.play(); if (p2 && p2.catch) p2.catch(function () {}); });
    });
  });
  dlg.querySelector('[data-gk-pipdlg-close]').addEventListener('click', close);
  dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
  dlg.addEventListener('close', function () { vid.pause(); });
})();
